<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="音容笑貌"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
      <template #right>
        <div v-if="isSelf" class="iconbtn" style="color:white" @click="clickEdit">{{editName}}</div>
        <!-- <div class="iconbtn">
          <van-icon name="share" @click="shareHandler" />
        </div>-->
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="photos-content">
      <van-tabs
        v-model="active"
        sticky
        animated
        swipeable
        offset-top="46"
        title-active-color="#fff"
        title-inactive-color="#f2f2f2"
        background="#24a378"
        color="#fff"
        :border="false"
        @change="selectItem"
      >
        <van-tab title="照片" >
          <memorialHall_image
            ref="childimg"
            :id="this.id+''"
            :isSelf="isSelf"
            :ischeckShow="ischeckShow"
          ></memorialHall_image>
          <!-- <div class="tab-box" :style="'height:'+(fullHeight-44)+'px;'">
  			  	<div class="tab-scroll">
	  			  	<router-link to="/ImageDetails" class="photo-list" v-for="item in 6" :key="item.id">
	  		        <div class="hd">
	  		        	<img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
	  		        </div>
	  		        <div class="bd">
	  		        	<h2 class="title van-multi-ellipsis--l2">时光留影</h2>
	  		        	<span class="totalnum">19张</span>
	  		        </div>
	  			  	</router-link>
  			  	</div>
  			  	<router-link to="/ImageAdd" class="addBtn"><i class="fa fa-camera"></i></router-link>
          </div>-->
        </van-tab>
        <van-tab title="视频" >
          <memorialHall_video
            ref="childvideo"
            :id="this.id+''"
            :isSelf="isSelf"
            :ischeckShow="ischeckShow"
          ></memorialHall_video>
          <!-- <div class="tab-box" :style="'height:'+(fullHeight-44)+'px;'">
    	  		<div class="tab-scroll">
	  			  	<router-link to="/VideoDetails" class="video-list" v-for="item in 4" :key="item.id">
	  		        <div class="hd">
	  		        	<img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
	  		        	<div class="playIcon"><van-icon name="play-circle-o" color="#fff" size="36" /></div>
	  		        </div>
	  		        <div class="bd">
	  		        	<h2 class="title van-multi-ellipsis--l2">时光留影</h2>
	  		        	<p class="date">2016-01-06 14:46:12</p>
	  		        </div>
	  			  	</router-link>
  			  	</div>
  			  	<router-link to="/VideoAdd" class="addBtn"><i class="fa fa-video-camera"></i></router-link>
          </div>-->
        </van-tab>
        <van-tab title="音频" >
          <memorialHall_musicinfo
            ref="childmusic"
            :id="this.id+''"
            :isSelf="isSelf"
            :ischeckShow="ischeckShow"
          ></memorialHall_musicinfo>
          <!-- <div class="tab-box" :style="'height:'+(fullHeight-44)+'px;'">
    	  		<div class="tab-scroll">
	  			  	<router-link to="/MusicDetails" class="audio-list" v-for="item in 4" :key="item.id">
	  		        <div class="hd">
	  		        	<i class="fa fa-music"></i>
	  		        </div>
	  		        <div class="bd">
	  		        	<div class="title">记录这一刻</div>
	  		        	<p class="date">2016-01-06 14:46:12</p>
	  		        </div>
	  			  	</router-link>
  			  	</div>
  			  	<router-link to="/MusicAdd" class="addBtn"><i class="fa fa-cloud-upload"></i></router-link>
          </div>-->
        </van-tab>
      </van-tabs>
      <router-link v-if="active == 0 && currentToken.isLogin&&isSelf == true && ischeckShow == false" :to="{path:'/ImageAdd',query:{id:id}}"  class="addBtn"><i class="fa fa-camera"></i></router-link>
      <div v-if="active == 0 && currentToken.isLogin&&isSelf == true && ischeckShow"  class="addBtn"  @click="delimage" ><van-icon name="delete" /></div>
      <router-link v-if="active == 1 && currentToken.isLogin&&isSelf == true && ischeckShow == false" :to="'/VideoAdd?id='+id" class="addBtn"><i class="fa fa-video-camera"></i></router-link>
      <div v-if="active == 1 && currentToken.isLogin&&isSelf == true && ischeckShow" class="addBtn" @click="delVideo"><van-icon name="delete" /></div>
      <router-link  v-if="active == 2 && currentToken.isLogin&&isSelf == true && ischeckShow == false" :to="{name:'MusicAdd', params:{id:this.$route.query.id}}" class="addBtn"><i class="fa fa-cloud-upload"></i></router-link>
      <div v-if="active == 2 && currentToken.isLogin&&isSelf == true && ischeckShow"  class="addBtn"  @click="delMusic" ><van-icon name="delete" /></div>
    </div>
  </div>
</template>

<script>
import soshm from "soshm";
import memorialHall_image from "@/components/memorialHall/memorialHall_image";
import memorialHall_video from "@/components/memorialHall/memorialHall_video";
import memorialHall_musicinfo from "@/components/memorialHall/memorialHall_musicinfo";
import { mapGetters, mapState } from "vuex";
import auth from "../../../tools/auth";

export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight - 50 - 46,
      id: "0",
      editName: "编辑",
      isSelf: false,
      ischeckShow: false,
      active: 0,
      scrollmap:{}
    };
  },
  components: {
    memorialHall_image,
    memorialHall_video,
    memorialHall_musicinfo
  },

  computed: {
    ...mapGetters(["currentToken"])
  },
  watch: {
    // fullHeight(val) {
    //   //监控浏览器高度变化
    //   if (!this.timer) {
    //     this.fullHeight = val;
    //     this.timer = true;
    //     let that = this;
    //     setTimeout(function() {
    //       that.timer = false;
    //     }, 400);
    //   }
    // },
    'active' : function (newVal, oldVal){
      var top = document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollmap[oldVal] = top;
    }  
  },
  mounted() {
    // this.get_bodyHeight();
  },
  
  methods: {
    // get_bodyHeight() {
    //   //动态获取浏览器高度
    //   const that = this;
    //   window.onresize = () => {
    //     return (() => {
    //       window.fullHeight = document.documentElement.clientHeight - 50 - 46;
    //       that.fullHeight = window.fullHeight;
    //     })();
    //   };
    // },
    onClickLeft() {
      this.$router.go(-1);
    },
    delimage(){
      this.$refs.childimg.delimage();
    },
    delVideo(){
      this.$refs.childvideo.delVideo();
    },
    delMusic(){
      this.$refs.childmusic.delMusic();
    },
    /**推荐给朋友**/
    shareHandler() {
      soshm.popIn({
        title: "弹窗分享",
        sites: ["weixin", "weixintimeline", "weibo", "qzone", "tqq", "qq"]
      });
    },
    getIsSelf() {
      var that = this;
      this.$store
        .dispatch({
          type: "getIsSelfMemorialHall",
          id: that.id,
          Mid: 0
        })
        .then(res => {
          that.isSelf = res == true;
        });
    },
    clickEdit() {
      this.ischeckShow = !this.ischeckShow;
      this.editName = this.ischeckShow ? "取消" : "编辑";
    },
    selectItem(index, name){
      var that = this;
      this.$nextTick(() => {
          window.scrollTo(0, that.scrollmap[that.active]);
      })
    },
    getMemorialHall(id){
      var that = this;
      that.$store
        .dispatch({
          type: "GetMemorialHallSearchApiById",
          id: id
        })
        .then(
          (res) => {
            var memorialHallapiModel = res.MemorialHallSearchApiModel;
            if (memorialHallapiModel.IsPrivacy) {
              var _id = memorialHallapiModel.SerialNumber;
              auth.IsFriend(this, _id);
            }
          },
          (err) => {}
        );
    }
  },
  
  activated(){
    var that = this;
    that.id = this.$route.query.id + "";
    this.getMemorialHall(that.id);
    if(this.currentToken && this.currentToken.isLogin){
      this.getIsSelf();
    }
    
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.ischeckShow = false;
    if(to.name != 'ImageAdd' && to.name != 'VideoAdd' &&to.name != 'MusicAdd' && to.name != 'ImageDetails'&& to.name != 'VideoDetails'){
      this.active = 0;
      this.scrollmap = {};
      let oAudio = document.querySelector("#audio");
      if (this.$store.state.isPlaying) {
        oAudio.play();
      }else{
        oAudio.pause();
      }
    }
    next();
  },
  created() {
    var that = this;
    that.id = this.$route.query.id + "";
    if(this.currentToken && this.currentToken.isLogin){
      this.getIsSelf();
    }
  }
};
</script>

<style scoped>
.photo-list {
  display: flex;
  align-items: center;
  margin: 10px;
  background-color: #f2f2f2;
  height: 128px;
}
.photo-list > .hd {
  flex: 1;
  width: 100%;
  height: 100%;
}
.photo-list > .hd > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.photo-list > .bd {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.photo-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
}
.photo-list > .bd > .totalnum {
  font-size: 12px;
  color: #999;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.video-list {
  display: block;
  margin: 15px;
  border-radius: 6px;
  box-shadow: 0 0 4px #ddd;
  background-color: #f2f2f2;
}
.video-list > .hd {
  position: relative;
  height: 0;
  font-size: 0;
  padding-bottom: 56%;
  width: 100%;
}
.video-list > .hd > .avatar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px 6px 0 0;
}
.video-list > .hd > .playIcon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-list > .bd {
  padding: 10px;
}
.video-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.video-list > .bd > .date {
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list {
  margin: 15px;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  padding: 10px;
}
.audio-list > .hd {
  position: relative;
  margin-right: 15px;
}
.audio-list > .hd > i {
  color: #666;
  font-size: 24px;
}
.audio-list > .bd {
  flex: 1;
  overflow: hidden;
}
.audio-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list > .bd > .date {
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tab-box {
  position: relative;
}
.tab-scroll {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.photos-content .addBtn {
  position: fixed;
  bottom: 70px;
  right: 15px;
  width: 56px;
  height: 56px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 4px #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #24a378;
  z-index: 100;
}
</style>
